import { SocialProcurements } from "@stories/pages/Contractor/SocialProcurement/SocialProcurement";

export const SocialProcurementView = () => {
  return <SocialProcurements />;
};
